import { EAppNameEnum, TAppNameEnum } from '@onesource/schemas';

export interface TAppConfig {
  id: TAppNameEnum;
  name: {
    subscribed: string;
    unsubscribed: string;
  };
  description: string;
  url: string | undefined;
  icon: string;
  cardBackgroundColor: string;
  thumbnails: {
    default: string;
    TIER_1?: string;
    TIER_2?: string;
    TIER_3?: string;
  };
  tierLabels?: {
    TIER_1?: string;
    TIER_2?: string;
    TIER_3?: string;
  };
  salesPageUrl: string | undefined;
}

// All available apps CONFIGURATION, shared across web and mobile apps.
// `url` is env-dependent and left undefined here; consuming apps attach their own env-derived URL.
export const ALL_APPS: TAppConfig[] = [
  {
    id: EAppNameEnum.RYC,
    name: {
      subscribed: 'RYC<sup>®</sup>',
      unsubscribed: 'RYC<sup>®</sup> 12-Week Program',
    },
    description: 'Rock Your Core 12 Week Challenge',
    url: undefined,
    icon: 'mdi:yoga',
    cardBackgroundColor: '#CE3B4D',
    tierLabels: {
      TIER_1: 'Essentials',
      TIER_2: 'Guided',
      TIER_3: 'Coached',
    },
    thumbnails: {
      default: 'https://media.restoreyourcore.com/members/tier-1-essentials.webp',
      TIER_1: 'https://media.restoreyourcore.com/members/tier-1-essentials.webp',
      TIER_2: 'https://media.restoreyourcore.com/members/tier-2-guided.webp',
      TIER_3: 'https://media.restoreyourcore.com/members/tier-3-coached.webp',
    },
    salesPageUrl: 'https://restoreyourcore.com/restore-your-core/',
  },
  {
    id: EAppNameEnum.FIT,
    name: {
      subscribed: 'RYC<sup>®</sup> FIT',
      unsubscribed: 'RYC<sup>®</sup> FIT',
    },
    description: 'Access your fitness classes and workouts',
    url: undefined,
    icon: 'mdi:dumbbell',
    cardBackgroundColor: '#D4183D',
    thumbnails: {
      default: 'https://media.restoreyourcore.com/members/ryc-fit.webp',
    },
    salesPageUrl: 'https://restoreyourcore.com/fitness-membership/',
  },
] as const;
